// extracted by mini-css-extract-plugin
export default {"header-container":"Request_header-container__w91Pi","flex":"Request_flex__Vc+Vu"};